import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-library" }

import LibraryTable from "./library-table.vue";
import GameModal from "./game-modal.vue";
import LibraryEditBar from "./library-edit-bar.vue";
import { ref, computed, onMounted } from "vue";

interface Props {
  gamePurchasesUrl: string;
  userId: number;
  isEditable?: boolean;
  chevronDownIcon: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'library',
  props: {
    gamePurchasesUrl: {},
    userId: {},
    isEditable: { type: Boolean, default: false },
    chevronDownIcon: {}
  },
  setup(__props: any) {

const props = __props;

// Reactive data
const isModalActive = ref(false);
const isEditBarActive = ref(false);
const selectedGamePurchases = ref<any[]>([]);
const currentGame = ref<any>({});
const doesGamePurchaseExist = ref(false);
const games = ref<any[]>([]);
const isLoading = ref(true);

// Methods
function loadGames(): void {
  fetch(props.gamePurchasesUrl, {
    headers: {
      "Content-Type": "application/json"
    }
  })
    .then((response) => {
      return response.json().then((json) => {
        if (response.ok) {
          return Promise.resolve(json);
        }
        return Promise.reject(json);
      });
    })
    .then((purchasedGames) => {
      games.value = purchasedGames;
      isLoading.value = false;

      // Make sure to trigger bulma:init, even if the load event has already fired.
      // This can theoretically trigger a race condtion because readyState
      // will be set to complete right before the load event is fired, but yolo.
      if (document.readyState === "complete") {
        // Emit a bulma init event to make sure that the filter dropdown is initialized.
        let event = new Event("bulma:init");
        document.body.dispatchEvent(event);
      } else {
        window.addEventListener("load", (_loadEvent) => {
          // Emit a bulma init event to make sure that the filter dropdown is initialized.
          let event = new Event("bulma:init");
          document.body.dispatchEvent(event);
        });
      }
    });
}

function refreshLibrary() {
  loadGames();
}

function activateModal(game: any = {}) {
  if (!props.isEditable) {
    return;
  }
  document.documentElement.classList.add("is-clipped");

  // TODO: Probably replace this with a check for null/undefined?
  doesGamePurchaseExist.value = Object.entries(game).length > 0 ? false : true;
  currentGame.value = game;
  isModalActive.value = true;
}

function deactivateModal() {
  document.documentElement.classList.remove("is-clipped");

  isModalActive.value = false;
}

function activateEditBar() {
  isEditBarActive.value = true;
}

function deactivateEditBar() {
  isEditBarActive.value = false;
}

function selectedGamePurchasesChanged(gamePurchases: any[]) {
  if (gamePurchases.length > 0) {
    activateEditBar();
  } else {
    deactivateEditBar();
  }
  selectedGamePurchases.value = gamePurchases;
}

function closeEditBar() {
  // This will clear the selected games and deactivate the edit bar.
  selectedGamePurchasesChanged([]);
}

function closeAndRefresh() {
  deactivateModal();
  // Give it some time for the change to persist on the backend.
  setTimeout(() => {
    refreshLibrary();
  }, 750);
}

// Computed properties
const gameModalState = computed(() => {
  let currentGameExists = Object.keys(currentGame.value).length > 0;
  return currentGameExists ? "update" : "create";
});

// Lifecycle
onMounted(() => {
  loadGames();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isEditBarActive.value)
      ? (_openBlock(), _createBlock(LibraryEditBar, {
          key: 0,
          gamePurchases: selectedGamePurchases.value,
          onCloseEditBar: closeEditBar
        }, null, 8, ["gamePurchases"]))
      : _createCommentVNode("", true),
    _createVNode(LibraryTable, {
      rows: games.value,
      isEditable: __props.isEditable,
      isLoading: isLoading.value,
      chevronDownIcon: __props.chevronDownIcon,
      onEdit: activateModal,
      onDelete: refreshLibrary,
      onAddGame: _cache[0] || (_cache[0] = ($event: any) => (activateModal({}))),
      onSelectedGamePurchasesChanged: selectedGamePurchasesChanged
    }, null, 8, ["rows", "isEditable", "isLoading", "chevronDownIcon"]),
    (isModalActive.value)
      ? (_openBlock(), _createBlock(GameModal, _mergeProps({
          key: 1,
          isActive: isModalActive.value,
          gameModalState: gameModalState.value,
          userId: __props.userId
        }, currentGame.value, {
          onClose: deactivateModal,
          onCloseAndRefresh: closeAndRefresh,
          onCreate: refreshLibrary
        }), null, 16, ["isActive", "gameModalState", "userId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})